import axios from 'axios';

export const getEoreTemplates = async (page, dateFrom, dateTo, signal) => {
  const pageParam = page ? `?page=${page}` : '';
  const dateFromParam = dateFrom ? `&date_from=${dateFrom}` : '';
  const dateToParam = dateTo ? `&date_to=${dateTo}` : '';
  const url = `/reports/eore/templates/${pageParam}${dateFromParam}${dateToParam}`;
  const config = signal ? { signal } : {};
  const response = await axios.get(url, config);
  return response;
};

export const postEoreTemplate = async (body, templateName) => {
  const templateNameParam = templateName ? `?template_name=${templateName}` : '';
  const url = `/reports/eore/templates/${templateNameParam}`;
  const response = await axios.post(url, body);
  return response;
};

export const getEoreTemplateFile = async (fileId) => {
  const url = `/reports/eore/templates/${fileId}/download/`;
  const response = await axios.get(url, { responseType: 'blob' });
  return response;
};

export const deleteEoreTemplate = async (id) => {
  const url = `/reports/eore/templates/${id}/`;
  const response = await axios.delete(url);
  return response;
};

export const getEoreReports = async (page, dateFrom, dateTo, userId, ordering, signal) => {
  const pageParam = page ? `?page=${page}` : '';
  const dateFromParam = dateFrom ? `&date_from=${dateFrom}` : '';
  const dateToParam = dateTo ? `&date_to=${dateTo}` : '';
  const userIdParam = userId ? `&user_id=${userId}` : '';
  const orderingParam = ordering ? `&ordering=${ordering}` : '';
  const url = `/reports/eore/${pageParam}${dateFromParam}${dateToParam}${userIdParam}${orderingParam}`;
  const config = signal ? { signal } : {};
  const response = await axios.get(url, config);
  return response;
};

export const getEoreReportsWithFilters = async (filters, signal) => {
  const params = new URLSearchParams();

  if (filters?.page) params.append('page', filters.page);
  if (filters?.dateFrom) params.append('date_from', filters.dateFrom);
  if (filters?.dateTo) params.append('date_to', filters.dateTo);
  if (filters?.userId) params.append('user_id', filters.userId);
  if (filters?.ordering) params.append('ordering', filters.ordering);

  if (filters.selectedStatus?.length > 0) {
    filters.selectedStatus?.forEach(status => params.append('validation_status', status?.value || status));
  }
  if (filters.selectedDonor?.length > 0) {
    filters?.selectedDonor?.forEach(donor => params.append('donor', donor?.value || donor));
  }
  if (filters.selectedCustomer?.length > 0) {
    filters?.selectedCustomer?.forEach((customer) => params.append('task-customer', customer?.value || customer));
  }
  if (filters.selectedTeam?.length > 0) {
    filters?.selectedTeam?.forEach(team => params.append('team_id', team?.value || team));
  }
  if (filters?.selectedLocalCommunity?.length > 0) {
    filters?.selectedLocalCommunity?.forEach(community => params.append('local_community', community?.value || community));
  }
  if (filters.selectedSettlement?.length > 0) {
    filters?.selectedSettlement?.forEach(settlement => params.append('settlement_name', settlement?.value || settlement));
  }
  if (filters?.selectedTypeOfPlace?.length > 0) {
    filters?.selectedTypeOfPlace?.forEach(place => params.append('place_type_imsma', place?.value || place));
  }
  if (filters?.selectedTypeOfSession?.length > 0) {
    filters?.selectedTypeOfSession?.forEach(session => params.append('eore_type_imsma', session?.value || session));
  }
  if (filters?.selectedBeneficiaries?.min) {
    params.append('beneficiaries_min', filters?.selectedBeneficiaries?.min);
  }
  if (filters?.selectedBeneficiaries?.max) {
    params.append('beneficiaries_max', filters.selectedBeneficiaries.max);
  }

  const url = `/reports/eore/?${params.toString()}`;
  const config = signal ? { signal } : {};
  const response = await axios.get(url, config);
  return response;
};

export const deleteEoreReport = async (id) => {
  const url = `/reports/eore/${id}/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteAllUserHandouts = async (userId) => {
  const url = `/reports/eore/handouts/${userId}/user/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteAllUserFiles = async (userId) => {
  const url = `/reports/clearance/files/${userId}/user/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteAllUserMethods = async (userId) => {
  const url = `/reports/clearance/methods/${userId}/user/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteHandoutById = async (handoutId) => {
  const url = `/reports/eore/handouts/${handoutId}/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteMethodById = async (methodId) => {
  const url = `/reports/clearance/methods/${methodId}/`;
  const response = await axios.delete(url);
  return response;
};

export const deleteFileById = async (fileId) => {
  const url = `/reports/clearance/files/${fileId}/`;
  const response = await axios.delete(url);
  return response;
};

export const createOrUpdateEoreHandouts = async (handouts) => {
  const url = '/reports/eore/handouts/';
  const response = await axios.put(url, handouts);
  return response;
};

export const createOrUpdateClearanceMethods = async (methods) => {
  const url = '/reports/clearance/methods/';
  const response = await axios.put(url, methods);
  return response;
};

export const createOrUpdateClearanceFiles = async (files) => {
  const url = '/reports/clearance/files/';
  const response = await axios.put(url, files);
  return response;
};

export const getHandouts = async () => {
  const url = '/reports/eore/handouts/';
  const response = await axios.get(url);
  return response;
};

export const postEoreReport = async (body) => {
  const url = '/reports/eore/';
  const response = await axios.post(url, body);
  return response;
};

export const getEoreCurrentTemplateVersion = async () => {
  const url = '/reports/eore/templates/version/';
  const response = await axios.get(url);
  return response;
};

export const getEoreReportById = async (id) => {
  const url = `/reports/eore/${id}/`;
  const response = await axios.get(url);
  return response;
};

export const updateEoreReportById = async (id, body) => {
  const url = `/reports/eore/${id}/`;
  const response = await axios.patch(url, body);
  return response;
};

export const updateEoreReportPhotos = async (id, body) => {
  const url = `/reports/eore/${id}/images/`;
  const response = await axios.patch(url, body);
  return response;
};

export const updateReportAttachments = async (id, body) => {
  const url = `/reports/eore/${id}/files/`;
  const response = await axios.patch(url, body);
  return response;
};

export const getEOREGeojson = async (options = {}) => {
  const url = `/reports/eore/global-map/`;
  const response = await axios.get(url, options);
  return response;
};